
import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../model/api-response-model';
import { VMS_Notification } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private crudSer: CrudService) {

  }


  GetAllNotifications(): Observable<any> {
    return this.crudSer.get<any>('Notification/GetAllNotifications');
  }

  GetNotification(id: number): Observable<any> {
    return this.crudSer.get<any>('Notification/GetNotification/' + id);
  }

  GetPageNotifications(id: number = 0, pageId: number = 0): Observable<ApiResponseModel> {
    return this.crudSer.get<any>('Notification/GetPageNotifications?pageId=' + pageId);
  }

  SaveNotification(model: VMS_Notification): Observable<ApiResponseModel> {
    return this.crudSer.post<any>('Notification/SaveNotification', model);
  }

  UploadFiles(model: any): Observable<ApiResponseModel>{
    return this.crudSer.post<any>('Notification/Uploads', model);
  }

  GetDownloadBaseURL():string
  {
    return this.crudSer.DownLoadURl;
  }
}
